<template>
  <div>
    <el-row :gutter="20" style="width:100%">
      <el-col :span="12" :offset="3" >
        <myMenu v-if="$route.path!='/'" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import myMenu from "@/components/menu.vue";
import langSelect from "@/components/langSelect";
export default {
  name: "menus",
  data() {
    /*var validateNew = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新密码"));
      }
      let config = this.pwdStrategy;
      if (config.enable == 1) {
        let pwdRule = config.pwdRule;
        let pwdLength = config.pwdLength;
        if (pwdRule) {
          if (value.length < pwdLength) {
            callback(new Error("新密码长度至少为" + pwdLength));
          } else if (pwdRule == 2) {
            var re = new RegExp("(?=.*[0-9])(?=.*[a-zA-Z])");
            if (!re.test(value)) {
              callback(new Error("新密码必须包含数字、字母"));
            } else {
              callback();
            }
          } else if (pwdRule == 3) {
            var re = new RegExp("(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9])");
            if (!re.test(value)) {
              callback(new Error("新密码必须包含数字、字母、特殊字符"));
            } else {
              callback();
            }
          } else if (pwdRule == 4) {
            var re = new RegExp(
              "(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9])"
            );
            if (!re.test(value)) {
              callback(new Error("新密码必须包含数字、大小字母、特殊字符"));
            } else {
              callback();
            }
          }
        }
      } else {
        if (value.length < 6) {
          callback(new Error("新密码长度至少为6"));
        } else {
          callback();
        }
      }
    };
    var validateold = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入旧密码"));
      } else {
        callback();
      }
    };
    var validateNewReapeat = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入新密码"));
      } else if (value !== this.pwdForm.new) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };*/
    return {
      /*logo: "",
      showLogo:true,
      infoDialogVisible: false,
      modifyPwdDialogVisible: false,
      userPhoto: require("@/assets/img/defaultPhoto.jpg"),
      pwdForm: {
        old: "",
        new: "",
        newRepeat: ""
      },
      pwdRules: {
        old: [{ validator: validateold, trigger: "blur" }],
        new: [{ validator: validateNew, trigger: "blur" }],
        newRepeat: [{ validator: validateNewReapeat, trigger: "blur" }]
      },
      count: 0,
      homePage: window.context.front +"/home"*/
    };
  },
  /*computed: mapState({
    postMap: state => state.user.postMap || {},
    currentUser: state => {
      return state.login.currentUser ? state.login.currentUser : {};
    },
    curUser: state => state.user.currentUserDetail || {},
    curOrg: state => state.user.currentOrgDetail || {},
    pwdStrategy: state => state.user.pwdStrategy || {}
  }),
  mounted() {
    const _this = this;
    const currentUser = this.$store.state.login.currentUser;
    if(currentUser){
      let userAttrs = this.$store.state.login.currentUser.userAttrs;
      if(userAttrs){
        let tenantId = userAttrs.tenantId;
        //租户
        if(tenantId && tenantId !="-1"){
          let url = window.context.uc+"/uc/tenantManage/v1/getJson?id=" + tenantId;
          this.$http.get(url).then(resp => {
            if(resp.data){
              let tenantManage = resp.data;
              if(tenantManage.frontLogo){
                let frontLogo = JSON.parse(tenantManage.frontLogo);
                if(frontLogo && frontLogo.length >0 ){
                  _this.showLogo = true;
                  _this.logo = window.context.portal + "/system/file/v1/downloadFile?fileId=" + frontLogo[0].id;
                }
              }
            }
          }, error => {
              reject(error);
          })
        }else{
          //不是租户
          _this.sysSetting();
        }
      }else{
        //不是租户
        _this.sysSetting();
      }
    }else{
      //不是租户
      _this.sysSetting();
    }
    setTimeout(() => {
      this.$route.path !== "/" &&
        this.$store.dispatch("user/loadCurrentUserDetail").then(data => {
          if (data) {
            var promise = this.$store.dispatch("user/getCurrent");
            promise.then(data => {
              if (data.photo && data.photo.indexOf("img/defaultPhoto") < 0) {
                this.$store
                  .dispatch("menu/downloadImg", data.photo)
                  .then(res => {
                    if (res != "") {
                      this.userPhoto = res;
                    }
                  });
              }
            });
          }
        });
    }, 1200);
  },
  watch: {
    //第一次加载著部门，当前切换岗位部门时当前部门发生改变
    "$store.state.user.postCharge": function() {
      const postCharge = this.$store.state.user.postCharge;
      this.count += 1;
      if (postCharge.org && this.count > 1) {
        this.$store.dispatch("user/setcurrentOrg", postCharge.org);
      }
    }
  },*/
  methods: {
    //获取系统默认配置 系统Logo、名称
    /*sysSetting(){
      const _this = this;
      let url = window.context.portal+"/sys/sysProperties/v1/getDecryptBySysSetting";
      _this.$http.get(url).then(response => {
          if(response && response.data && response.data.value){
            let  sysSettingData = JSON.parse(response.data.value);
            if(sysSettingData.frontLogo.length>0){
              let frontLogo = sysSettingData.frontLogo;
              _this.showLogo = true;
              _this.logo = window.context.portal + "/system/file/v1/downloadFile?fileId=" + frontLogo[0].id;
            }else{
              this.logo = require("@/assets/img/logo.png");
            }
          }else{
            this.logo = require("@/assets/img/logo.png");
          }
      });
    },
    open() {
      this.$store.dispatch("user/getDefPwdStrategy");
    },
    handleCommand(command) {
      switch (command) {
        case "logout":
		  //退出登陆时把vuex 里面的一些值清空
          this.$store.dispatch("menu/setCopyMenus",[]);//菜单
          let loginRouthPath =
            localStorage.getItem(
              this.$store.state.login.currentUser.account + "loginRoutePath"
            ) || "/login";
          this.$store.dispatch("login/logoutAndCleanUp").then(() => {
            switch (window.ssoConfig.mode) {
              case "cas":
                window.sessionStorage.removeItem("currentUser");
                window.location.href =
                  window.ssoConfig.logout +
                  "?service=" +
                  window.location.href.split("?")[0];
                break;
              case "oauth":
                break;

              default:
                this.$router.push({
                  path: loginRouthPath
                });
                break;
            }
          });
          break;
        case "info":
          this.infoDialogVisible = true;
          break;
        case "modifyPwd":
          this.modifyPwdDialogVisible = true;
          if (this.$refs["pwdForm"]) {
            this.$refs["pwdForm"].resetFields();
          }
          break;
      }
    },
    submitForm() {
      this.$refs["pwdForm"].validate(valid => {
        if (valid) {
          this.$store
            .dispatch("user/modifyPwd", {
              oldPwd: this.pwdForm.old,
              newPwd: this.pwdForm.new
            })
            .then(data => {
              if (data.state) {
                this.$message.success("修改密码成功");
                this.modifyPwdDialogVisible = false;
              } else {
                this.$message.error(data.message || "保存失败");
              }
            });
        }
      });
    },
    switchPost(item) {
      for (let obj in this.postMap) {
        this.postMap[obj].disabled = false;
      }
      item.disabled = true;
      //设置表单中当前岗位
      this.$store.dispatch("user/setpostMap", {
        postMap: this.postMap,
        postCharge: item
      });
      this.$store.dispatch("user/putInCacheOrgPost", {
        postMap: this.postMap,
        postCharge: item
      }).then(res => {
        this.$store.dispatch("user/setMasterByorgId",{
          orgid:item.orgid,
          userid:this.currentUser.userId
        }).then(resp => {
          debugger
          this.$message.success(resp.message);
        });
      });
      
      this.infoDialogVisible = true;
      this.infoDialogVisible = false;
    }*/
  },
  components: {
    myMenu,
    langSelect
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";
.theme-color{
  color: $--color-text-regular;
}

/deep/ .el-col-12 {//避免菜单栏目名称过长造成挤压
    padding: 0px !important;
    margin: 0px !important;
    width: 90%;
}

.el-row {
  text-color: #ededed;
  active-text-color: #fff;
  margin: 0 -20px;
}

img {
  margin-top: 5px;
}

div.el-dropdown, div.el-dropdown + span {
  color: #333333;
  font-size: 13px;
}



.el-form /deep/ .el-form-item__content > .el-tag {
  margin-right: 10px;
}

.content_span {
  color: #212121;
  border-bottom: 1px solid #ededed;
  width: 260px;
  display: inline-block;
  margin: 0 30px 0 10px;
}

#modlfy-dialog /deep/ .el-input__inner {
  width: 200px;
}



</style>


